module.exports = __webpack_public_path__ + "img/SKMJ_grinder1.591795b6.jpg";